import styled from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";
import {GAMING_HISTORY_PAGE, SESSION_HISTORY_PAGE} from "../../../../themes/css-global-classes";

const CommonStyles = styled.div`
   width: 100%;
   height: 2px;
   background: linear-gradient(to right, transparent, ${props => props.theme.colors.textLight} 40%, transparent);

   .${GAMING_HISTORY_PAGE} &, .${SESSION_HISTORY_PAGE} &{
      background: linear-gradient(to right, transparent, ${props => props.theme.colors.brandPrimary} 40%, transparent);
   }
`;
const PCBox = styled(CommonStyles)`
  margin-top: 12px;
`;

const MobileBox = CommonStyles;

export const LobbyHeaderLineCasino777Box = styledByDevice(PCBox, MobileBox);